import { render, staticRenderFns } from "./app-table.vue?vue&type=template&id=e91c0b00&scoped=true&"
import script from "./app-table.vue?vue&type=script&lang=js&"
export * from "./app-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e91c0b00",
  null
  
)

export default component.exports